export default __webpack_public_path__ + "static/media/up-down.1ea4541b.svg";